module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Diegten-d133283ef73e9bc22d4b218529c3758c.png";